/* eslint-disable */
import React from 'react'
import Loadable from 'react-loadable'

const Loading = (props) => {
  if (props.error) {
    return <div>Error! <button onClick={props.retry}>Retry</button></div>;
  } else if (props.timedOut) {
    return <div>Taking a long time... <button onClick={props.retry}>Retry</button></div>;
  } else if (props.pastDelay) {
    return <div>Loading...</div>;
  } else {
    return null;
  }
}

const LoadableWrapper = (opts) => {
  return Loadable(Object.assign({
    delay: 300,
    timeout: 10000,
    loading: Loading,
    render(loaded, props) {
      let Component = loaded.default
      return <Component {...props} />
    }
  }, opts))
}

export const LoadableStudentFAQ = LoadableWrapper({
  loader: () => import('../../../lcrp/components/StudentFAQ')
})

export const LoadableActivity = LoadableWrapper({
  loader: () => import('../Activity')
})

export const LoadableLCRPSplitPane = LoadableWrapper({
  loader: () => import('../../../lcrp/components/LCRPSplitPane')
})

export const LoadableStudentInsights = LoadableWrapper({
  loader: () => import('../../../lcrp/components/StudentInsights')
})

export const LoadableAboutLearningCurve = LoadableWrapper({
  loader: () => import('../Instructor/AboutLearningCurve')
})

export const LoadableInsightsTrends = LoadableWrapper({
  loader: () => import('../Instructor/InsightsTrends')
})
